// src/pages/Trader/OrdersAndWithdrawals/Settlements/components/Content/components/Blocks/SettlementsBlocks.tsx
import React, { useMemo } from 'react';
import { useGetSettlementsQuery } from '../../../../../../../../redux/services/SettlementsApi';
import { TSettlementModel }      from '../../../../../../../../redux/types/SettlementsTypes';
import { FilterValues }          from '../../../CustomFilterModal/CustomFilterModal';

interface Props {
  filter?: FilterValues | null;
}

const SettlementsBlocks: React.FC<Props> = ({ filter }) => {
  const { data, error, isLoading } =
    useGetSettlementsQuery(undefined, { pollingInterval: 10000 });

  if (isLoading) return <div>Загрузка заявок...</div>;
  if (error)     return <div>Ошибка загрузки заявок</div>;
  if (!data || data.length === 0)
    return <div className="no-data-icon">Нет заявок для отображения</div>;

  const filtered = useMemo(() => {
    if (!filter) return data;
    return data.filter((s: TSettlementModel) => {
      if (filter.direction !== 'all' && s.direction !== filter.direction) return false;
      if (filter.status    !== 'all' && s.status    !== filter.status)    return false;
      if (filter.amountFrom !== ''  && s.amount < filter.amountFrom)     return false;
      if (filter.amountTo   !== ''  && s.amount > filter.amountTo)       return false;
      const dt = new Date(s.created_at);
      if (filter.dateFrom && dt < new Date(filter.dateFrom)) return false;
      if (filter.dateTo   && dt > new Date(filter.dateTo))   return false;
      return true;
    });
  }, [data, filter]);

  if (filtered.length === 0)
    return <div className="no-data-icon">Нет заявок по выбранным фильтрам</div>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
      {filtered.map(s => {
        const wallet =
          s.direction_display === 'Мерчант → Площадка'
            ? s.platform_wallet_address
            : s.merchant_wallet_address;

        return (
          <div key={s.id} className="border rounded-lg shadow p-4">
            <div><strong>ID:</strong> {s.id}</div>
            <div><strong>Дата:</strong> {s.created_at}</div>
            <div><strong>Направление:</strong> {s.direction_display}</div>
            <div><strong>Кошелек:</strong> {wallet}</div>
            <div><strong>Валюта:</strong> {s.currency}</div>
            <div><strong>Сумма:</strong> {s.amount}</div>
            <div><strong>Статус:</strong> {s.status_display}</div>

            <div className="mt-2">
              <strong>Комментарий:</strong>
              {s.comment ? (
                <p className="whitespace-pre-wrap mt-1">{s.comment}</p>
              ) : (
                <p className="text-gray-400 mt-1">Комментарий отсутствует</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SettlementsBlocks;
